import { EuiComboBox, EuiComboBoxOptionOption, EuiFlexGroup, EuiFormLabel } from '@elastic/eui';
import { useIntl } from 'react-intl';
import { isVehicleCoveredByWarranty } from 'cache';
import { useLocalCache } from 'hooks/useLocalCache';

import * as S from './FiltersSidebar.styles';

export const VehicleCoveredByWarrantyFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const getCurrentOption = (selected?: boolean | null): { label: string; value?: boolean } => {
    if (typeof selected === 'undefined') return { label: 'Tutte' };
    if (selected === true) return { label: 'Con garanzia', value: selected };
    if (selected === false) return { label: 'Senza garanzia', value: selected };
    return { label: 'Tutte' };
  };

  return (
    <S.SidebarFilterWrapper>
      <EuiFlexGroup direction="column">
        <EuiFormLabel style={{ marginRight: '10px' }}>
          {formatMessage({ id: 'filters.isVehicleCoveredByWarranty.label' })}
        </EuiFormLabel>
        <EuiComboBox
          aria-label="Accessible screen reader label"
          placeholder="Select a single option"
          isClearable={false}
          singleSelection={{ asPlainText: true }}
          options={[
            { label: 'Con garanzia', value: true },
            { label: 'Senza garanzia', value: false },
            { label: 'Tutte', value: undefined },
          ]}
          selectedOptions={[
            getCurrentOption(localFilters?.data?.isVehicleCoveredByWarranty) as EuiComboBoxOptionOption<boolean | null>,
          ]}
          onChange={(x): void => {
            isVehicleCoveredByWarranty(x[0]?.value);
          }}
        />
      </EuiFlexGroup>
    </S.SidebarFilterWrapper>
  );
};
